export default {
    'UsedTime': '已用时{time}',
    'FlowTrack': '流程跟踪',
    'Participant': '当前处理人',
    'Participants': '当前处理人:',
    'FinishNode': '已办节点',
    'ProcessNode': '进行中节点',
    'WrongNode': '异常节点',
    'UnstartNode': '未开始',
    'Person': '{length}人',
    'chartTips': '流程图可手势调整大小',
    'trust': '【{name}委托】',
    'WorkflowActionStatus': {
        'Submit': '提交',
        'Submits': '提交',
        'Cancel': '作废',
        'Agree': '同意',
        'DisAgree': '不同意',
        'AdjustParticipant': '加签',
        'Assist': '协办',
        'Forward': '转办',
        'Reject': '驳回',
        'FinishInstance': '结束流程',
        'UnRead': '待阅',
        'Read': '已阅',
        'Circularize': '传阅',
        'Empty': '',
        'Revoke': '撤回',
        'BeCanceled': '被取消',
        'AutoCanceled': '自动取消',
    },
    'WorkItemStatus': {
        'NotStarted': '未启动',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '被取消',
        'Draft': '草稿',
        'BeCanceled': '被取消',
    },
};
